export * from "./shared.module";
export * from "./animations";
export * from "./no-content";
export * from "./notification";
export * from "./interfaces";
export * from "./data.model";
export * from "./error.model";
export * from "./capslock.directive";
export * from "./confirmation-session.dto";
export * from "./catalogs";



// WEBPACK FOOTER //
// ./src/app/shared/index.ts